import { render, staticRenderFns } from "./addOrganization.vue?vue&type=template&id=36f0be01&"
import script from "./addOrganization.vue?vue&type=script&lang=js&"
export * from "./addOrganization.vue?vue&type=script&lang=js&"
import style0 from "./addOrganization.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports